export enum JobStatus {
  RUNNING = 'Running',
  CLOSED = 'Closed',
}
